import type React from 'react';

import { Button } from '@change/ds-core-ui/Button';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@change/ds-core-ui/Modal';
import { Text } from '@change/ds-core-ui/Text';

import { useI18n } from '@change-corgi/core-react/i18n';

import { useHighAmountConfirmationModal } from './hooks/useHighAmountConfirmationModal';

export const HighAmountConfirmationModal: React.FC<EmptyProps> = () => {
	const { translate } = useI18n();
	const {
		data: { text, cancelLabel, confirmLabel, ariaLabel, showHighAmountConfirmationModal },
		actions: { confirmPromotionHighAmount, cancelHighAmountConfirmation },
	} = useHighAmountConfirmationModal();

	return (
		<Modal
			isOpen={showHighAmountConfirmationModal}
			aria-label={ariaLabel}
			onClose={cancelHighAmountConfirmation}
			closeButtonAriaLabel={translate('corgi.components.modal.close_button')}
			className="z-999 *:min-h-[100px]!"
			size="small"
		>
			<ModalHeader />
			<ModalBody>
				<div className="mx-auto flex flex-col items-center gap-4 pt-4">
					<Text size="medium">{text}</Text>
				</div>
			</ModalBody>
			<ModalFooter>
				<Button
					onClick={confirmPromotionHighAmount}
					data-qa="payment-high-amount-button-confirm-yes"
					variant="primary"
					size="small"
				>
					{confirmLabel}
				</Button>
				<Button
					onClick={cancelHighAmountConfirmation}
					data-qa="payment-high-amount-button-confirm-no"
					variant="secondary"
					size="small"
				>
					{cancelLabel}
				</Button>
			</ModalFooter>
		</Modal>
	);
};
